/**
 * Corresponds to GpfError in gpf-starter-web
 */
var GpfError = /** @class */ (function () {
    function GpfError(tag, message, status, statusCode, correlationId, errors) {
        this.tag = tag;
        this.message = message;
        this.status = status;
        this.statusCode = statusCode;
        this.correlationId = correlationId;
        this.errors = errors;
    }
    GpfError.parse = function (json) {
        var x = JSON.parse(json);
        if (!(x instanceof Object))
            throw SyntaxError('A GpfError has to be an object');
        if (x.tag === undefined ||
            x.message === undefined ||
            x.status === undefined ||
            x.statusCode === undefined) {
            throw SyntaxError('A required field of GpfError was missing');
        }
        return x;
    };
    // Note: Do not add any non-static methods to GpfError, as any instances
    // created by doing `const err: GpfError = JSON.parse(jsonString)` will
    // not have such methods. `GpfError.parse(jsonString)` should be preferred,
    // but let's try to avoid easily created confusing bugs.
    GpfError.getErrorMessageForField = function (gpfError, field) {
        if (!gpfError || !gpfError.errors) {
            return undefined;
        }
        var error = gpfError.errors.find(function (value) { return value.field === field; });
        return error ? error.message : undefined;
    };
    GpfError.removeErrorMessageForField = function (gpfError, field) {
        if (!gpfError || !gpfError.errors) {
            return gpfError;
        }
        return new GpfError(gpfError.tag, gpfError.message, gpfError.status, gpfError.statusCode, gpfError.correlationId, gpfError.errors.filter(function (value) { return value.field !== field; }));
    };
    return GpfError;
}());
export { GpfError };
